export const BaseUrl = 'https://techprimelab-heaz.onrender.com'
